import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Spin } from 'antd'
import qs from 'qs'
import Empty from 'meinian-package/src/baseComponent/empty'
import request from 'meinian-package/src/utils/request'
import isIPad from 'meinian-package/src/common/isIPad'
import { useRequest } from 'ahooks'
import { isObject, isString } from 'meinian-package/src/utils/type'
import PieAttrChart2 from '../../../component/pieAttrChart2'
import { ELEMENT_KEYS_ENUM, ELEMENT_KEYS_MAP, ELEMENT_KEYS_ENUM_BOOT } from '../../../component/filter/element/element'
import getAnalysisHrefQueryString from '../styleFilter/getAnalysisHrefQueryString'
import styles from './index.module.less'

const PIE_LINK_TYPE = {
  DEFAULT: 'DEFAULT',
  NONE: 'NONE',
  IF_HIDDEN: 'IF_HIDDEN'
}
const LINK_KEY_TYPE = {
  LEVEL: 'LEVEL',
  CUSTOM: 'CUSTOM'
}

const textGroup = [
  { title: '品类分析',
    text: '品类占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: 'category'
  },
  { title: '颜色分析', text: '颜色占比', hrefType: PIE_LINK_TYPE.IF_HIDDEN, linkKey: ELEMENT_KEYS_ENUM.COLOR },
  { title: '风格分析', text: '风格占比', hrefType: PIE_LINK_TYPE.IF_HIDDEN, linkKey: ELEMENT_KEYS_ENUM.STYLE },
  { title: '图案分析',
    text: '图案占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM.DESIGN
    }
  },
  { title: '面料材质分析',
    text: '面料材质占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.CUSTOM,
      keys: [{ key: ELEMENT_KEYS_ENUM.FABRIC, value: ELEMENT_KEYS_MAP.fabric }, ELEMENT_KEYS_ENUM.FABRIC_MATERIAL],
    }
  },
  { title: '面料工艺分析',
    text: '面料工艺占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.CUSTOM,
      keys: [{ key: ELEMENT_KEYS_ENUM.FABRIC, value: ELEMENT_KEYS_MAP.fabric }, ELEMENT_KEYS_ENUM.FABRIC_CRAFT]
    }
  },
  { title: '工艺分析',
    text: '工艺占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM.CRAFT
    }
  },
  { title: '廓形分析', text: '廓形占比', hrefType: PIE_LINK_TYPE.IF_HIDDEN, linkKey: ELEMENT_KEYS_ENUM.SILHOUETTE },
  { title: '辅料分析',
    text: '辅料占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM.ACCESSORIES
    }
  },
  { title: '领型分析',
    text: '领型占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM.COLLAR_TYPE
    }
  },
]

const textGroupBoot = [ // 鞋靴
  { title: '品类分析',
    text: '品类占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: 'category'
  },
  { title: '面料分析',
    text: '面料占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: ELEMENT_KEYS_ENUM_BOOT.FABRIC
  },
  { title: '鞋跟分析',
    text: '鞋跟占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM_BOOT.HEEL
    }
  },
  { title: '鞋带分析',
    text: '鞋带占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM_BOOT.SHOELACE
    }
  },
  { title: '鞋帮分析',
    text: '鞋帮占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM_BOOT.UPPER
    }
  },
  { title: '鞋头分析',
    text: '鞋头占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM_BOOT.TOE
    }
  },
  { title: '开口分析',
    text: '开口占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM_BOOT.SHOES
    }
  },
  { title: '筒高分析',
    text: '筒高占比',
    hrefType: PIE_LINK_TYPE.IF_HIDDEN,
    linkKey: {
      type: LINK_KEY_TYPE.LEVEL,
      keys: ELEMENT_KEYS_ENUM_BOOT.TUBE
    }
  },
]

const transformData = (_data = [], parentItemKey = null) => {
  if (!_data.length) return
  _data.forEach(item => {
    item.name = item.itemName
    item.id = item.itemKey
    item.parentItemKey = parentItemKey
    transformData(item.children, item.itemKey)
  })
}

export default forwardRef(({ style, baseParams }, ref) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [data, setData] = useState([])
  const [priceData, setPriceData] = useState({})
  const [typeData, setTypeData] = useState({})
  const [dataSource, setDataSource] = useState([])
  const groupDom = useRef(null)

  const { loading, run, params: [_param] } = useRequest((_params) => request.get('/zhikuan/mn/collect-statistic/v2/tag-distributions', {
    params: _params,
  }), {
    manual: true,
    onSuccess: (result) => {
      result.pieCharts.forEach((item, index) => {
        item.blogNum = result.blogNum
        if (_param.gender == '鞋靴') {
          item.title = textGroupBoot?.[index]?.title
          item.centerText = textGroupBoot?.[index]?.text
          item.hrefType = textGroupBoot?.[index]?.hrefType
          item.linkKey = textGroupBoot?.[index]?.linkKey
        } else {
          item.title = textGroup[index].title
          item.centerText = textGroup[index].text
          item.hrefType = textGroup[index].hrefType
          item.linkKey = textGroup[index].linkKey
        }
        transformData(item.items)
      })
      console.log('result', result)
      setData(result)
    }
  })
  const fetchPriceData = (_params) => {
    request.get('/zhikuan/mn/collect-statistic/v2/price-distributions', {
      params: _params,
    }).then((result) => {
      result.pieCharts.forEach((item) => {
        item.title = '价格带分析'
        item.centerText = '价格带占比'
        item.blogNum = result.blogNum
        item.hrefType = PIE_LINK_TYPE.DEFAULT
        item.linkKey = ELEMENT_KEYS_ENUM.PRICES
        transformData(item.items)
      })
      setPriceData(result)
    })
  }

  const fetchTypeData = (_params) => {
    request.get('/zhikuan/mn/collect-statistic/v2/notetype-distributions', {
      params: _params,
    }).then((result) => {
      result.pieCharts.forEach((item) => {
        item.title = '类型分析'
        item.centerText = '类型占比'
        item.blogNum = result.blogNum
        item.hrefType = PIE_LINK_TYPE.NONE
        transformData(item.items)
      })
      setTypeData(result)
    })
  }

  useEffect(() => {
    init(baseParams)
  }, [])

  useImperativeHandle(ref, () => ({
    onUpdate: init
  }))

  const init = (_params) => {
    run(_params)
    fetchPriceData(_params)
    fetchTypeData(_params)
  }

  const columnRef = useRef(2)

  useEffect(() => {
    const onResize = () => {
      const { width } = groupDom.current.getBoundingClientRect()
      const _data = []
      const pieCharts = [].concat(priceData?.pieCharts).concat(typeData?.pieCharts).concat(data?.pieCharts)
      if (width < 1620 && columnRef.current != 2) {
        columnRef.current = 2
      } else if (width > 1620 && columnRef.current != 3) {
        columnRef.current = 3
      }
      for (let i = 0; i < pieCharts?.length; i += columnRef.current) {
        if (columnRef.current === 2) {
          _data.push([pieCharts[i], pieCharts[i + 1]])
        } else {
          _data.push([pieCharts[i], pieCharts[i + 1], pieCharts[i + 2]])
        }
      }
      setDataSource(_data)
    }
    onResize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [data, priceData, typeData])

  const getHref = (val, item) => {
    if (item.hrefType === PIE_LINK_TYPE.NONE) {
      return false
    }
    const _query = {}
    if (!isObject(item?.linkKey) && isString(item.linkKey) && item.linkKey) {
      _query[item?.linkKey] = val.itemKey
    } else if (item.linkKey?.type === LINK_KEY_TYPE.LEVEL) {
      _query[item?.linkKey.keys] = val.parentItemKey ? `${val.itemKey},${val.parentItemKey}` : `${val.itemKey},`
    } else if (item.linkKey?.type === LINK_KEY_TYPE.CUSTOM) {
      item.linkKey.keys.forEach(i => {
        if (isObject(i)) {
          _query[i.key] = i.value
        } else {
          _query[i] = val.itemKey
        }
      })
    }
    if (item.hrefType === PIE_LINK_TYPE.DEFAULT) {
      return getHrefUrl(_query)
    }
    if (item.hrefType === PIE_LINK_TYPE.IF_HIDDEN && baseParams.gender) {
      const __query = {
        gender: baseParams.gender,
        ..._query,
      }
      return getHrefUrl(__query)
    }
    return false
  }

  const getHrefUrl = (__query) => {
    const baseQueryString = getAnalysisHrefQueryString({ ...baseParams, ...__query })
    delete __query.gender
    delete __query.category
    const _queryString = new URLSearchParams(Object.entries(__query)).toString()
    const queryString = `${baseQueryString}&${_queryString}`
    let href = ''
    if (location.pathname.startsWith('/meinian/home/coll/detail') && query.inspirationId) {
      href = `${location.pathname + location.search}&${queryString}`
    } else {
      href = `/meinian/home/all?${queryString}`
    }
    return href
  }
  return (<div className={styles['meinian-style-analysis']} style={style}>
    <Spin spinning={loading}>
      <div className="meinian-style-analysis-block-group" ref={groupDom}>
        {
        dataSource.map((row) => <div
          className="meinian-style-analysis-block-group-row"
          style={{
            display: `${isIPad ? 'block' : 'flex'}`,
          }}
        >
          {
            row?.map((item) => (item ? <div
              className="meinian-style-analysis-block"
              style={{
                marginLeft: `${isIPad && '0'}`,
                marginTop: `${isIPad && '24px'}`,
              }}
            >
              <div className="meinian-style-analysis-block-title">
                {item?.title}
                <span className="meinian-style-analysis-block-title-num">{item?.blogNum}</span>
              </div>
              {item?.blogNum && item.items.length ? <PieAttrChart2
                centerText={item.centerText}
                data={item.items}
                dataset={{ source: item?.source }}
                getHref={(val) => getHref(val, item)}
              /> : <Empty type="analysis" noPadding style={{ height: 'unset' }} />}
            </div> : <div
              className="meinian-style-analysis-block"
              style={{
                opacity: 0
              }}
            />))
          }
        </div>)
      }
      </div>
    </Spin>
  </div>)
})
